import { AppEnv } from '../appEnv';
import { assertNever } from '../assertNever';

export type PortalUrl =
  | 'https://qa-media.smsc-nsc.com'
  | 'https://stg-media.smsc-nsc.com'
  | 'https://media.nurse-senka.jp';

export type AccountUrl =
  | 'https://qa-account.smsc-nsc.com'
  | 'https://stg-account.smsc-nsc.com'
  | 'https://account.nurse-senka.jp';

export type FortuneTellingUrl =
  | 'https://qa-fortune-telling.smsc-nsc.com'
  | 'https://stg-fortune-telling.smsc-nsc.com'
  | 'https://fortune-telling.nurse-senka.jp';

export type WorkplaceReputationUrl =
  | 'https://qa-workplace-reputation.smsc-nsc.com'
  | 'https://stg-workplace-reputation.smsc-nsc.com'
  | 'https://workplace-reputation.nurse-senka.jp';

export type RecruitUrl =
  | 'https://qa-recruit.smsc-nsc.com'
  | 'https://stg-recruit.smsc-nsc.com'
  | 'https://recruit.nurse-senka.jp';

export type NurseSquareUrl =
  | 'https://qa-square.smsc-nsc.com'
  | 'https://stg-square.smsc-nsc.com'
  | 'https://square.nurse-senka.jp';

export type KnowledgeNurseSenkaUrl =
  | 'https://qa-knowledge.smsc-nsc.com'
  | 'https://stg-knowledge.smsc-nsc.com'
  | 'https://knowledge.nurse-senka.jp';

export type LoungeUrl =
  | 'https://qa-lounge.smsc-nsc.com'
  | 'https://stg-lounge.smsc-nsc.com'
  | 'https://lounge.nurse-senka.jp';

export type MedicalTerm =
  | 'https://qa-medical-term.smsc-nsc.com'
  | 'https://stg-medical-term.smsc-nsc.com'
  | 'https://medical-term.nurse-senka.jp';

export type SurveyUrl =
  | 'https://qa-survey.smsc-nsc.com'
  | 'https://stg-survey.smsc-nsc.com'
  | 'https://survey.nurse-senka.jp';

export type InsuranceUrl =
  | 'https://hoken.nurse-senka.jp'
  | 'https://stg-hoken.smsc-nsc.com'
  | 'https://qa-hoken.smsc-nsc.com';

export const portalUrl = (appEnv: AppEnv): PortalUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-media.smsc-nsc.com';
    case 'qa':
      return 'https://qa-media.smsc-nsc.com';
    case 'production':
      return 'https://media.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const accountUrl = (appEnv: AppEnv): AccountUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-account.smsc-nsc.com';
    case 'qa':
      return 'https://qa-account.smsc-nsc.com';
    case 'production':
      return 'https://account.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const fortuneTellingUrl = (appEnv: AppEnv): FortuneTellingUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-fortune-telling.smsc-nsc.com';
    case 'qa':
      return 'https://qa-fortune-telling.smsc-nsc.com';
    case 'production':
      return 'https://fortune-telling.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const workplaceReputationUrl = (
  appEnv: AppEnv,
): WorkplaceReputationUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-workplace-reputation.smsc-nsc.com';
    case 'qa':
      return 'https://qa-workplace-reputation.smsc-nsc.com';
    case 'production':
      return 'https://workplace-reputation.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const recruitUrl = (appEnv: AppEnv): RecruitUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-recruit.smsc-nsc.com';
    case 'qa':
      return 'https://qa-recruit.smsc-nsc.com';
    case 'production':
      return 'https://recruit.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const nurseSquareUrl = (appEnv: AppEnv): NurseSquareUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-square.smsc-nsc.com';
    case 'qa':
      return 'https://qa-square.smsc-nsc.com';
    case 'production':
      return 'https://square.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const knowledgeNurseSenkaUrl = (
  appEnv: AppEnv,
): KnowledgeNurseSenkaUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-knowledge.smsc-nsc.com';
    case 'qa':
      return 'https://qa-knowledge.smsc-nsc.com';
    case 'production':
      return 'https://knowledge.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const loungeUrl = (appEnv: AppEnv): LoungeUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-lounge.smsc-nsc.com';
    case 'qa':
      return 'https://qa-lounge.smsc-nsc.com';
    case 'production':
      return 'https://lounge.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const medicalTerm = (appEnv: AppEnv): MedicalTerm => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-medical-term.smsc-nsc.com';
    case 'qa':
      return 'https://qa-medical-term.smsc-nsc.com';
    case 'production':
      return 'https://medical-term.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const surveyUrl = (appEnv: AppEnv): SurveyUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-survey.smsc-nsc.com';
    case 'qa':
      return 'https://qa-survey.smsc-nsc.com';
    case 'production':
      return 'https://survey.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};

export const insuranceUrl = (appEnv: AppEnv): InsuranceUrl => {
  switch (appEnv) {
    case 'local':
    case 'staging':
      return 'https://stg-hoken.smsc-nsc.com';
    case 'qa':
      return 'https://qa-hoken.smsc-nsc.com';
    case 'production':
      return 'https://hoken.nurse-senka.jp';
    default:
      return assertNever(appEnv);
  }
};
